export const Navroutes = [
  {
    name: "Home",
    path: "/home",
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2318_336)">
          <path
            d="M12.0003 14.6667H12.0085M9.30712 4.42383L3.96937 9.09425C3.51103 9.49483 3.81903 10.2062 4.44878 10.2062C4.83378 10.2062 5.14637 10.4949 5.14637 10.8506V13.8243C5.14637 16.3818 5.14637 17.6605 6.00712 18.4552C6.86695 19.25 8.25112 19.25 11.0213 19.25H12.9793C15.7485 19.25 17.1336 19.25 17.9935 18.4552C18.8542 17.6605 18.8542 16.3818 18.8542 13.8243V10.8506C18.8542 10.4949 19.1659 10.2062 19.5509 10.2062C20.1815 10.2062 20.4886 9.49483 20.0312 9.09425L14.6934 4.42383C13.4184 3.30917 12.7804 2.75 12.0003 2.75C11.2202 2.75 10.5822 3.30825 9.30712 4.42383Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2318_336">
            <rect width="22" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    key: 0,
  },
  {
    name: "Company",
    path: "/company/dashboard",
    icon: (
      <svg
        width="26"
        height="22"
        viewBox="0 0 26 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7291 6.05127L23.0991 2.09253V19.8597H16.7291V6.05127ZM16.7291 6.05127L17.0807 5.99533L8.76562 3.57784V19.856H16.7291V6.05127Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.39551 8.63662L8.76551 3.57788V19.8579H2.39551V8.63662Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.8335 7.69995L15.1668 8.79995V11L10.8335 9.89995V7.69995Z" />
        <path d="M10.8335 11L15.1668 12.1V14.3L10.8335 13.2V11Z" />
        <path d="M10.8335 14.3L15.1668 15.4V17.6L10.8335 16.5V14.3Z" />
        <path d="M7.5835 6.6001L3.25016 9.9001V12.1001L7.5835 8.8001V6.6001Z" />
        <path d="M21.6665 5.5L18.4165 7.7V9.9L21.6665 7.7V5.5Z" />
        <path d="M21.6665 8.80005L18.4165 11V13.2L21.6665 11V8.80005Z" />
        <path d="M21.6665 12.1001L18.4165 14.3001V16.5001L21.6665 14.3001V12.1001Z" />
      </svg>
    ),
    key: 1,
    subroutes: [
      {
        name: "Dashboard",
        path: "/company/dashboard",
        exact: true,
      },
      {
        name: "Goals",
        path: "/company/goals",
        exact: true,
      },
      {
        name: "People",
        path: "/company/people",
        exact: true,
      },
      {
        name: "TouchBase",
        path: "/company/touchbase",
        exact: true,
      },
      {
        name: "Insight",
        path: "/company/insight",
        exact: true,
      },
    ],
  },
  {
    name: "TouchBase",
    path: "/touchbase/templates",
    key: 2,
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.75 9.16669C2.75 5.50002 4.58333 3.66669 8.25 3.66669M18.3333 13.75C18.3333 17.4167 16.5 19.25 12.8333 19.25M12.8333 8.25002C12.8333 5.71865 14.8853 3.66669 17.4167 3.66669H19.25V10.0834H12.8333V8.25002ZM2.75 12.8334H9.16667V14.6667C9.16667 17.1981 7.11471 19.25 4.58333 19.25H2.75V12.8334Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    subroutes: [
      {
        name: "Templates",
        path: "/touchbase/templates",
        exact: true,
      },
      {
        name: "Schedule",
        path: "/touchbase/schedule",
        exact: true,
      },
    ],
  },
  {
    name: "Integration",
    path: "/integrations",
    key: 3,
    icon: (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.9688 11.5C18.4629 11.5 18.9271 11.5936 19.3613 11.7808C19.7956 11.9679 20.1737 12.2262 20.4956 12.5557C20.8175 12.8851 21.0758 13.2669 21.2705 13.7012C21.4652 14.1354 21.5625 14.5996 21.5625 15.0938C21.5625 15.5879 21.4689 16.0521 21.2817 16.4863C21.0946 16.9206 20.8363 17.3024 20.5068 17.6318C20.1774 17.9613 19.7956 18.2196 19.3613 18.4067C18.9271 18.5939 18.4629 18.6875 17.9688 18.6875C17.542 18.6875 17.134 18.6164 16.7446 18.4741C16.3553 18.3319 16.0034 18.1297 15.689 17.8677C15.3745 17.6056 15.1087 17.2987 14.8916 16.9468C14.6745 16.5949 14.5247 16.2093 14.4424 15.79C13.7012 15.7451 12.9824 15.6104 12.2861 15.3857C11.5898 15.1611 10.9272 14.8617 10.2983 14.4873C9.66943 14.113 9.09668 13.6712 8.58008 13.1621C8.06348 12.653 7.59928 12.084 7.1875 11.4551V15.8799C7.60677 15.9697 7.99235 16.1232 8.34424 16.3403C8.69613 16.5575 8.99935 16.8195 9.25391 17.1265C9.50846 17.4334 9.70687 17.7853 9.84912 18.1821C9.99137 18.5789 10.0625 18.987 10.0625 19.4062C10.0625 19.9004 9.96891 20.3646 9.78174 20.7988C9.59456 21.2331 9.33626 21.6149 9.00684 21.9443C8.67741 22.2738 8.29557 22.5321 7.86133 22.7192C7.42708 22.9064 6.96289 23 6.46875 23C5.97461 23 5.51042 22.9064 5.07617 22.7192C4.64193 22.5321 4.26009 22.2775 3.93066 21.9556C3.60124 21.6336 3.34294 21.2518 3.15576 20.8101C2.96859 20.3683 2.875 19.9004 2.875 19.4062C2.875 18.9795 2.94613 18.5715 3.08838 18.1821C3.23063 17.7928 3.42904 17.4447 3.68359 17.1377C3.93815 16.8307 4.24137 16.5649 4.59326 16.3403C4.94515 16.1157 5.33073 15.9622 5.75 15.8799V7.12012C5.33073 7.03027 4.94515 6.87679 4.59326 6.65967C4.24137 6.44255 3.93815 6.1805 3.68359 5.87354C3.42904 5.56657 3.23063 5.21468 3.08838 4.81787C2.94613 4.42106 2.875 4.01302 2.875 3.59375C2.875 3.09961 2.96859 2.63542 3.15576 2.20117C3.34294 1.76693 3.59749 1.38883 3.91943 1.06689C4.24137 0.744954 4.62321 0.486654 5.06494 0.291992C5.50667 0.0973307 5.97461 0 6.46875 0C6.96289 0 7.42708 0.0935872 7.86133 0.280762C8.29557 0.467936 8.67367 0.726237 8.99561 1.05566C9.31755 1.38509 9.57585 1.76693 9.77051 2.20117C9.96517 2.63542 10.0625 3.09961 10.0625 3.59375C10.0625 4.02051 9.99137 4.4248 9.84912 4.80664C9.70687 5.18848 9.51221 5.53662 9.26514 5.85107C9.01807 6.16553 8.71484 6.43131 8.35547 6.64844C7.99609 6.86556 7.61426 7.01904 7.20996 7.10889C7.28483 8.07471 7.52441 8.97689 7.92871 9.81543C8.33301 10.654 8.8571 11.3989 9.50098 12.0503C10.1449 12.7017 10.8898 13.2295 11.7358 13.6338C12.5819 14.0381 13.4878 14.2777 14.4536 14.3525C14.5435 13.9408 14.6969 13.5589 14.9141 13.207C15.1312 12.8551 15.3932 12.5557 15.7002 12.3086C16.0072 12.0615 16.3553 11.8631 16.7446 11.7134C17.134 11.5636 17.542 11.4925 17.9688 11.5ZM4.3125 3.59375C4.3125 3.89323 4.36865 4.17399 4.48096 4.43604C4.59326 4.69808 4.74674 4.92643 4.94141 5.12109C5.13607 5.31576 5.36442 5.46924 5.62646 5.58154C5.88851 5.69385 6.16927 5.75 6.46875 5.75C6.76823 5.75 7.04899 5.69385 7.31104 5.58154C7.57308 5.46924 7.80143 5.31576 7.99609 5.12109C8.19076 4.92643 8.34424 4.69808 8.45654 4.43604C8.56885 4.17399 8.625 3.89323 8.625 3.59375C8.625 3.29427 8.56885 3.01351 8.45654 2.75146C8.34424 2.48942 8.19076 2.26107 7.99609 2.06641C7.80143 1.87174 7.57308 1.71826 7.31104 1.60596C7.04899 1.49365 6.76823 1.4375 6.46875 1.4375C6.16927 1.4375 5.88851 1.49365 5.62646 1.60596C5.36442 1.71826 5.13607 1.87174 4.94141 2.06641C4.74674 2.26107 4.59326 2.48942 4.48096 2.75146C4.36865 3.01351 4.3125 3.29427 4.3125 3.59375ZM8.625 19.4062C8.625 19.1068 8.56885 18.826 8.45654 18.564C8.34424 18.3019 8.19076 18.0736 7.99609 17.8789C7.80143 17.6842 7.57308 17.5308 7.31104 17.4185C7.04899 17.3062 6.76823 17.25 6.46875 17.25C6.16927 17.25 5.88851 17.3062 5.62646 17.4185C5.36442 17.5308 5.13607 17.6842 4.94141 17.8789C4.74674 18.0736 4.59326 18.3019 4.48096 18.564C4.36865 18.826 4.3125 19.1068 4.3125 19.4062C4.3125 19.7057 4.36865 19.9865 4.48096 20.2485C4.59326 20.5106 4.74674 20.7389 4.94141 20.9336C5.13607 21.1283 5.36442 21.2817 5.62646 21.394C5.88851 21.5063 6.16927 21.5625 6.46875 21.5625C6.76823 21.5625 7.04899 21.5063 7.31104 21.394C7.57308 21.2817 7.80143 21.1283 7.99609 20.9336C8.19076 20.7389 8.34424 20.5106 8.45654 20.2485C8.56885 19.9865 8.625 19.7057 8.625 19.4062ZM17.9688 17.25C18.2682 17.25 18.549 17.1938 18.811 17.0815C19.0731 16.9692 19.3014 16.8158 19.4961 16.6211C19.6908 16.4264 19.8442 16.1981 19.9565 15.936C20.0688 15.674 20.125 15.3932 20.125 15.0938C20.125 14.7943 20.0688 14.5135 19.9565 14.2515C19.8442 13.9894 19.6908 13.7611 19.4961 13.5664C19.3014 13.3717 19.0731 13.2183 18.811 13.106C18.549 12.9937 18.2682 12.9375 17.9688 12.9375C17.6693 12.9375 17.3885 12.9937 17.1265 13.106C16.8644 13.2183 16.6361 13.3717 16.4414 13.5664C16.2467 13.7611 16.0933 13.9894 15.981 14.2515C15.8687 14.5135 15.8125 14.7943 15.8125 15.0938C15.8125 15.3932 15.8687 15.674 15.981 15.936C16.0933 16.1981 16.2467 16.4264 16.4414 16.6211C16.6361 16.8158 16.8644 16.9692 17.1265 17.0815C17.3885 17.1938 17.6693 17.25 17.9688 17.25Z" />
      </svg>
    ),
  },
  {
    name: "iMongu Academy",
    path: "/academy",
    key: 4,
    icon: (
      <svg
        width="27"
        height="21"
        viewBox="0 0 27 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M27 6.38471C26.046 7.03519 25.3845 7.39199 24.5858 7.89563C19.9148 10.9405 15.417 14.3216 11.9329 18.7949L10.2589 21L5.11988 12.1796C6.2685 13.1675 9.12938 15.9393 10.2983 16.5473L14.0738 13.4818C16.7018 11.4866 24.138 7.13956 27 6.38471ZM9.05175 14.3847C9.441 14.7209 9.83025 15.0364 10.1419 15.2876C10.998 10.8362 10.278 6.04854 8.02013 1.89078C11.8159 1.82767 15.5925 1.78519 19.3882 1.72209C20.2397 3.74805 20.7348 5.927 20.8485 8.14806C21.1792 7.95874 21.51 7.79126 21.8419 7.62257C21.7249 5.35558 21.1208 2.87743 19.9721 0.0218445C14.7949 -1.35629e-07 9.63563 0 4.45838 0C7.8255 4.30461 9.36337 9.51335 9.05175 14.3847ZM8.35087 13.7973C8.44875 13.9017 8.56575 13.9854 8.6625 14.0704C8.50725 9.93325 7.06612 5.71238 4.3605 2.07888H1.94625C5.4315 5.54369 7.55325 9.7233 8.35087 13.7973ZM7.51387 12.9988C7.63087 13.1044 7.74787 13.2087 7.884 13.335C6.8715 10.2694 5.0805 7.24515 2.55037 4.59951H0C3.25125 7.11893 5.76225 10.0376 7.51387 12.9988Z" />
      </svg>
    ),
    // subroutes: [
    //   {
    //     name: "academy ",
    //     path: "/academy/new",
    //     exact: true,
    //   },
    // ],
  },
];

export const StaticRoutes = [
  {
    name: "Trash",
    path: "/trash",
    key: 1,
    icon: (
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.2 3C11.7302 3 11.246 3.161 10.9058 3.49263C10.5665 3.8225 10.4 4.29325 10.4 4.75V5.625H5V7.375H5.9V21.375C5.9 22.8144 7.1195 24 8.6 24H19.4C20.8805 24 22.1 22.8144 22.1 21.375V7.375H23V5.625H17.6V4.75C17.6 4.29325 17.4344 3.8225 17.0933 3.49175C16.754 3.16275 16.2707 3 15.8 3H12.2ZM12.2 4.75H15.8V5.625H12.2V4.75ZM7.7 7.375H20.3V21.375C20.3 21.8606 19.8995 22.25 19.4 22.25H8.6C8.1005 22.25 7.7 21.8606 7.7 21.375V7.375ZM14 10L10.4 13.5H13.1V19.625H14.9V13.5H17.6L14 10Z" />
      </svg>
    ),
  },
  {
    name: "Settings",
    path: "/settings",
    key: 2,
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z"
          strokeWidth="1.5"
        />
        <path
          d="M12.6178 1.97268C12.2814 1.83334 11.8543 1.83334 10.9999 1.83334C10.1456 1.83334 9.71842 1.83334 9.38201 1.97268C9.15942 2.06481 8.95718 2.19991 8.78684 2.37026C8.6165 2.5406 8.4814 2.74284 8.38926 2.96543C8.30492 3.16984 8.27101 3.40909 8.25817 3.75651C8.25246 4.00767 8.18301 4.25325 8.05634 4.4702C7.92966 4.68715 7.74993 4.86834 7.53401 4.99676C7.31483 5.11963 7.06801 5.18477 6.81675 5.18605C6.56548 5.18734 6.31801 5.12472 6.09759 5.00409C5.78959 4.84093 5.56684 4.75109 5.34592 4.72176C4.86405 4.65839 4.37673 4.78896 3.99109 5.08476C3.70326 5.30751 3.48876 5.67693 3.06159 6.41668C2.63442 7.15643 2.41992 7.52584 2.37317 7.88793C2.34167 8.12667 2.35752 8.36929 2.4198 8.60191C2.48209 8.83454 2.58959 9.05261 2.73617 9.24368C2.87184 9.41968 3.06159 9.56726 3.35584 9.75243C3.78942 10.0247 4.06809 10.4885 4.06809 11C4.06809 11.5115 3.78942 11.9753 3.35584 12.2467C3.06159 12.4328 2.87092 12.5803 2.73617 12.7563C2.58959 12.9474 2.48209 13.1655 2.4198 13.3981C2.35752 13.6307 2.34167 13.8733 2.37317 14.1121C2.42084 14.4733 2.63442 14.8436 3.06067 15.5833C3.48876 16.3231 3.70234 16.6925 3.99109 16.9153C4.18216 17.0618 4.40023 17.1693 4.63285 17.2316C4.86548 17.2939 5.10809 17.3098 5.34684 17.2783C5.56684 17.2489 5.78959 17.1591 6.09759 16.9959C6.31801 16.8753 6.56548 16.8127 6.81675 16.814C7.06801 16.8152 7.31483 16.8804 7.53401 17.0033C7.97676 17.2599 8.23984 17.732 8.25817 18.2435C8.27101 18.5918 8.30401 18.8302 8.38926 19.0346C8.4814 19.2572 8.6165 19.4594 8.78684 19.6298C8.95718 19.8001 9.15942 19.9352 9.38201 20.0273C9.71842 20.1667 10.1456 20.1667 10.9999 20.1667C11.8543 20.1667 12.2814 20.1667 12.6178 20.0273C12.8404 19.9352 13.0427 19.8001 13.213 19.6298C13.3834 19.4594 13.5185 19.2572 13.6106 19.0346C13.6949 18.8302 13.7288 18.5918 13.7417 18.2435C13.76 17.732 14.0231 17.259 14.4658 17.0033C14.685 16.8804 14.9318 16.8152 15.1831 16.814C15.4344 16.8127 15.6818 16.8753 15.9023 16.9959C16.2103 17.1591 16.433 17.2489 16.653 17.2783C16.8918 17.3098 17.1344 17.2939 17.367 17.2316C17.5996 17.1693 17.8177 17.0618 18.0088 16.9153C18.2975 16.6934 18.5111 16.3231 18.9383 15.5833C19.3654 14.8436 19.5799 14.4742 19.6267 14.1121C19.6582 13.8733 19.6423 13.6307 19.58 13.3981C19.5178 13.1655 19.4103 12.9474 19.2637 12.7563C19.128 12.5803 18.9383 12.4328 18.644 12.2476C18.4293 12.1171 18.2512 11.9341 18.1266 11.7159C18.002 11.4976 17.935 11.2513 17.9318 11C17.9318 10.4885 18.2104 10.0247 18.644 9.75334C18.9383 9.56726 19.1289 9.41968 19.2637 9.24368C19.4103 9.05261 19.5178 8.83454 19.58 8.60191C19.6423 8.36929 19.6582 8.12667 19.6267 7.88793C19.579 7.52676 19.3654 7.15643 18.9392 6.41668C18.5111 5.67693 18.2975 5.30751 18.0088 5.08476C17.8177 4.93818 17.5996 4.83067 17.367 4.76839C17.1344 4.7061 16.8918 4.69026 16.653 4.72176C16.433 4.75109 16.2103 4.84093 15.9013 5.00409C15.681 5.12456 15.4337 5.18708 15.1826 5.1858C14.9316 5.18452 14.6849 5.11947 14.4658 4.99676C14.2499 4.86834 14.0702 4.68715 13.9435 4.4702C13.8168 4.25325 13.7474 4.00767 13.7417 3.75651C13.7288 3.40818 13.6958 3.16984 13.6106 2.96543C13.5185 2.74284 13.3834 2.5406 13.213 2.37026C13.0427 2.19991 12.8404 2.06481 12.6178 1.97268Z"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    name: "Help & Support",
    path: "/help&support",
    key: 4,
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 22L11.75 19H11.5C9.13333 19 7.125 18.175 5.475 16.525C3.825 14.875 3 12.8667 3 10.5C3 8.13333 3.825 6.125 5.475 4.475C7.125 2.825 9.13333 2 11.5 2C12.6833 2 13.7877 2.22067 14.813 2.662C15.8383 3.10333 16.7383 3.71167 17.513 4.487C18.2877 5.26233 18.8957 6.16233 19.337 7.187C19.7783 8.21167 19.9993 9.316 20 10.5C20 11.75 19.796 12.95 19.388 14.1C18.98 15.25 18.4213 16.3167 17.712 17.3C17.0027 18.2833 16.161 19.175 15.187 19.975C14.213 20.775 13.1507 21.45 12 22ZM14 18.35C15.1833 17.35 16.146 16.1793 16.888 14.838C17.63 13.4967 18.0007 12.0507 18 10.5C18 8.68333 17.3707 7.146 16.112 5.888C14.8533 4.63 13.316 4.00067 11.5 4C9.684 3.99933 8.14667 4.62867 6.888 5.888C5.62933 7.14733 5 8.68467 5 10.5C5 12.3153 5.62933 13.853 6.888 15.113C8.14667 16.373 9.684 17.002 11.5 17H14V18.35ZM11.475 15.975C11.7583 15.975 12 15.875 12.2 15.675C12.4 15.475 12.5 15.2333 12.5 14.95C12.5 14.6667 12.4 14.425 12.2 14.225C12 14.025 11.7583 13.925 11.475 13.925C11.1917 13.925 10.95 14.025 10.75 14.225C10.55 14.425 10.45 14.6667 10.45 14.95C10.45 15.2333 10.55 15.475 10.75 15.675C10.95 15.875 11.1917 15.975 11.475 15.975ZM10.75 12.8H12.25C12.25 12.3 12.3 11.95 12.4 11.75C12.5 11.55 12.8167 11.1833 13.35 10.65C13.65 10.35 13.9 10.025 14.1 9.675C14.3 9.325 14.4 8.95 14.4 8.55C14.4 7.7 14.1127 7.06267 13.538 6.638C12.9633 6.21333 12.284 6.00067 11.5 6C10.7667 6 10.15 6.20433 9.65 6.613C9.15 7.02167 8.8 7.51733 8.6 8.1L10 8.65C10.0833 8.36667 10.2417 8.08767 10.475 7.813C10.7083 7.53833 11.05 7.40067 11.5 7.4C11.95 7.39933 12.2877 7.52433 12.513 7.775C12.7383 8.02567 12.8507 8.30067 12.85 8.6C12.85 8.88333 12.7667 9.13767 12.6 9.363C12.4333 9.58833 12.2333 9.81733 12 10.05C11.4167 10.55 11.0627 10.946 10.938 11.238C10.8133 11.53 10.7507 12.0507 10.75 12.8Z" />
      </svg>
    ),
  },
];
// ${activeRoute === 1 ? "text-gray-900 " : ""}
